import { State, getState } from '../../js/utils/applicationState';
export function getExperiment(key, fallback) {
    const options = getState(State.options);
    return options?.[key] ?? fallback;
}
